import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Downloads from '../components/Downloads';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const DownloadPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col">
      <Header />

      <div className="flex-1 pt-16">
        {/* Downloads Component (incluye su propio hero y todas las cards) */}
        <Downloads />

        {/* Próximos pasos */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 pb-24">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border border-cyan-500/20 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-4">Próximos pasos</h2>
            <p className="text-slate-300 mb-6">
              Una vez descargado tu ZIP, abre <code className="font-mono bg-slate-800 px-2 py-0.5 rounded text-cyan-400">USO_RAPIDO.md</code> dentro del paquete. Para una guía general del lenguaje visita la documentación.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/docs">
                <Button className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-slate-950 font-semibold">
                  <BookOpen className="w-4 h-4 mr-2" />
                  Ver Documentación
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              <Link to="/embedded-scripting-language">
                <Button variant="outline" className="border-slate-700 text-white hover:bg-slate-800">
                  ¿Qué es BLOX Core?
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DownloadPage;
